import stores from 'cd-eft/models/Stores';

export interface IUGOInputs {
  readonly label?: string;
  readonly inputType: 'text' | 'number' | 'dropdown' | 'radio' | 'title' | 'checkbox';
  name: string;
  placeholder?: string;
  options?: any;
  readonly?: boolean;
  required?: boolean;
  disabled?: boolean;
}

const { ugoDesignStore } = stores.AppStore;

export const backFillSoilTypeOptions = [
  {
    name: 'Clay or Clay Loam',
    value: 'CLAY_OR_CLAY_LOAM'
  },
  {
    name: 'Coarse Sand or Gravel',
    value: 'COARSE_SAND_OR_GRAVEL'
  },
  {
    name: 'Sand or Sandy Loam',
    value: 'SAND_OR_SANDY_LOAM'
  },
  {
    name: 'Silty Clay Loam',
    value: 'SILTY_CLAY_LOAM'
  },
  {
    name: 'Silt or Silt Loam',
    value: 'SILT_OR_SILT_LOAM'
  }
]

export const UGOInputsConfig: Record<string, Record<string, IUGOInputs>> = {
  UGOInfoSection: {
    ugoName: {
      label: 'UGO Name',
      inputType: 'text',
      name: 'ugoName',
      placeholder: 'UGO Name...',
      required: true
    },
    backFillSoilType: {
      label: 'Back-Fill Soil Type',
      inputType: 'dropdown',
      name: 'backFillSoilType',
      options: backFillSoilTypeOptions,
      required: true
    },
    pipelineBenchmark: {
      label: 'Pipeline Benchmark (Optional)',
      inputType: 'title',
      name: 'pipelineBenchmark',
    },
    constructionBenchmark: {
      label: 'Construction Benchmark',
      inputType: 'text',
      name: 'constructionBenchmark',
      required: false,
    },
    benchmarkElevation: {
      label: 'Benchmark Elevation (ft)',
      inputType: 'number',
      name: 'benchmarkElevation',
      required: false,
    },
    benchmarkDescription: {
      label: 'Benchmark Description',
      inputType: 'text',
      name: 'benchmarkDescription',
      required: false,
    },
  },
  AlignmentSection: {
    alignment: {
      label: 'Alignment',
      inputType: 'dropdown',
      name: 'alignment',
      options: [],
      required: true
    },
  },
  PipelineDefaultSection: {
    material: {
      label: 'Material',
      inputType: 'dropdown',
      name: 'material',
      options: ugoDesignStore.pipelineMaterialOptions,
      required: true
    },
    pressurizable: {
      label: 'Pressurizable',
      inputType: 'checkbox',
      name: 'pressurizable',
      disabled: true,
    },
    pressureFlow: {
      label: 'Pressure Flow',
      inputType: 'checkbox',
      name: 'pressureFlow',
      disabled: true,
    },
    pipeSize: {
      label: 'Pipe Size (in)',
      inputType: 'number',
      name: 'pipeSize',
      required: true
    },
  },
}

export const backFillSoilTypeConfig = {
  'SILTY_CLAY_LOAM': 'SiltyClayLoam',
  'SAND_OR_SANDY_LOAM': 'SandOrSandyLoam',
  'SILT_OR_SILT_LOAM': 'SiltOrSiltLoam',
  'CLAY_OR_CLAY_LOAM': 'ClayOrClayLoam',
  'COARSE_SAND_OR_GRAVEL': 'CoarseSandOrGravel'
}